const url_market = () => window.domain_name;

const endpoints = {
  changeAvailablePlans: (controllerName, country) => {
    return `${url_market()}/${controllerName}/get_available_plans?country%5D=${country}`
  }
};

export default endpoints;
